import getBookOfSegment from './getBookOfSegment'

export const validateVersion = (AvailableContent, language, version) => {
  console.log('validateVersion')
  const hasContent = !!AvailableContent && AvailableContent.content
  if (!hasContent) return false;
  const langVerified = AvailableContent.content[language];
  const versionVerified = AvailableContent.content[language][version];
  return hasContent && langVerified && versionVerified
}

export const validateSegment = (AvailableContent, language, version, segment) => {
  console.log(
    "validateSegment",
    !!getBookOfSegment(segment, AvailableContent, language, version),
    getBookOfSegment(segment, AvailableContent, language, version)
  )
  return !!getBookOfSegment(segment, AvailableContent, language, version);
}